// AttendanceTable.jsx
const mockData = [
  {
    sNo: 1,
    empId: "4447",
    employee: "Abdullah Khan",
    designation: "ME",
    state: "MADHYA PRADESH",
    subState: "MADHYA PRADESH",
    hq: "ALIRAJPUR HQ",
    doj: "09 Apr 2018",
    manager: "Amardeep Shrivastava",
    mandatoryCanLogin: "✓",
    visits: "1",
    pob: "start",
    locTions: "2",
    gpsStop: "Idle Time",
    latestLocation: "Banpur, Khatali",
    morFldBy: "EX Station",
    eveFldBy: "EX KM One Way",
    morPunchTime: "SaF",
    evePunchTime: "H 08:21 AM",
    firstCallTime: "27 Oct 2025 09:53 AM",
    morStatus: "Present",
    eveStatus: "Absent",
    residenceAddress:
      "Boxa School Ke Patel Colony, Whatsapp (HADHYA PRADESH) 457887, Ward no",
    sms: "SMS",
  },
];

export default function AttendanceTable() {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      <div className="bg-gradient-to-r from-blue-600 to-blue-400 p-6">
        <h2 className="text-2xl font-bold text-white">Attendance Punched On</h2>
        <p className="text-blue-100 mt-2">
          27 Oct 2025 - Current Time 27 Oct 2025 09:55 AM
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead className="bg-blue-50 sticky top-0">
            <tr>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">S.No</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">Emp ID</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">Employee</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">Designation</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">State</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">Sub State</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">HQ</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">DOJ</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">Manager</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">Mandatory Can Login</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">Visits POB</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">Loc Tions GPS Stop</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">Latest Location</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">Mor Fld By Eve Fld By</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">Mor Punch Time Eve Punch Time</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">First Call Time Last Call Time</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">Mor Status Eve Status</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">Residence Address</th>
              <th className="border border-gray-300 px-2 py-2 text-left font-semibold text-gray-700">SMS</th>
            </tr>
          </thead>
          <tbody>
            {mockData.map((row) => (
              <tr key={row.sNo} className="hover:bg-gray-50 border-b border-gray-200">
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.sNo}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.empId}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.employee}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.designation}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.state}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.subState}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.hq}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.doj}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.manager}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700 text-center">{row.mandatoryCanLogin}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.visits}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.locTions}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.latestLocation}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.morFldBy}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.morPunchTime}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.firstCallTime}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700"><span className="text-green-600">{row.morStatus}</span></td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700 text-xs">{row.residenceAddress}</td>
                <td className="border border-gray-300 px-2 py-2 text-gray-700">{row.sms}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="bg-gray-50 px-6 py-4 flex gap-4 justify-center">
        <button className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 font-medium">Print</button>
        <button className="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-700 font-medium">Close</button>
        <button className="bg-green-600 text-white px-6 py-2 rounded-md hover:bg-green-700 font-medium">Export to Excel</button>
      </div>
    </div>
  );
}
